<template>
  <div class="q-pa-sm">
    <div class="text-h6" :class="$q.dark.mode ? '' : 'text-primary'">
      Broker Favourite
    </div>
    <q-card flat bordered>
      <q-tabs
        v-model="brokerFavouriteTabs"
        dense
        outside-arrows
        mobile-arrows
        :class="$q.dark.mode === true ? 'bg-grey-10' : 'text-grey-9 bg-grey-4'"
        active-color="white"
        :active-bg-color="$q.dark.mode === true ? 'grey-9' : 'blue-4'"
        :indicator-color="$q.dark.mode === true ? 'grey-7' : 'blue-5'"
        inline-label
        align="justify"
        narrow-indicator
      >
        <q-tab name="broker-favourite" label="Broker Favourite" no-caps />
        <q-tab
          name="broker-favourite-pro"
          label="Broker Favourite Pro"
          no-caps
        />
      </q-tabs>

      <q-tab-panels v-model="brokerFavouriteTabs" animated>
        <q-tab-panel class="q-px-none q-py-xs" name="broker-favourite">
          <BrokerFavourite
            @chartSymbol="
              (eventSymbol) => {
                symbol = eventSymbol;
              }
            "
          />
        </q-tab-panel>
        <q-tab-panel class="q-px-none q-py-xs" name="broker-favourite-pro">
          <BrokerFavouritePro
            @chartSymbol="
              (eventSymbol) => {
                symbol = eventSymbol;
              }
            "
        /></q-tab-panel>
      </q-tab-panels>
    </q-card>
  </div>
</template>
<script setup>
import { ref, watchEffect } from "vue";
import BrokerFavourite from "src/components/TradingviewOverView/BrokerFavourite/BrokerFavourite.vue";
import BrokerFavouritePro from "src/components/TradingviewOverView/BrokerFavourite/BrokerFavouritePro.vue";

const emit = defineEmits(["chartSymbol"]);

const brokerFavouriteTabs = ref("broker-favourite");
const symbol = ref("");

watchEffect(() => {
  if (symbol.value && symbol.value !== "") {
    emit("chartSymbol", symbol.value);
  }
});
</script>
